<template>
  <el-dialog
    :close-on-click-modal="false"
    title="输入密码"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="420px"
  >
    <section v-loading="getDetailLoading">
      <p style="margin-top: -24px; margin-bottom: 16px;">您已连续3次输入错误的支付密码，为了账户的安全，请获取超管手机号的验证码进行验证：</p>
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="captcha" slot-scope="prop">
          <el-input class="inputBox" v-model="prop.form.captcha">
            <article
              class="getCodeBtn"
              :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
              slot="suffix"
              @click="getSms"
            >{{ smsTime || '获取短信验证码' }}</article>
          </el-input>
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  checkSmsCode,
} from 'api/getPay';
export default {
  data () {
    return {
      smsTimer: null,
      smsTime: 0,

      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '超管手机',
            value: 'billId',
            type: 'input',
            readonly: true,
            placeholder: '请输入超管手机',
          },
          {
            label: '验证码',
            value: 'captcha',
            type: 'input',
            placeholder: '请输入验证码',
            slot: true,
          },
        ],
        rules: { // 表单验证规则
          billId: [
            { required: true, message: '请输入超管手机', trigger: 'blur' },
          ],
          captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getSms () {
      if (this.smsTime > 0) {
        return;
      }
      this.smsTime = 20;
      clearInterval(this.smsTimer);
      this.smsTimer = setInterval(() => {
        this.smsTime--;
        if (this.smsTime <= 0) {
          this.smsTime = 0;
          clearInterval(this.smsTimer);
        }
      }, 1000);
    },

    /**
     * @param {Object} item 修改的项
     * @param {Object} options 其他项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item, options = {}) {
      this.dialogFormVisible = true; // 打开弹窗

      this.setFormAttrVal({
        form: this.formData,
        attr: 'readonly',
        value: true,
        names: ['billId'],
      });

      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      if (!item.billId) {
        // 如果没有传入 手机号 ，则取消只读设置
        this.setFormAttrVal({
          form: this.formData,
          attr: 'readonly',
          value: false,
          names: ['billId'],
        });
      }
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.setVal('billId', item.billId || '');
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      const params = {
        captcha: this.encode(form.captcha),
        billId: form.billId,
      };
      this.subLoading = true;
      const res = await checkSmsCode(params);
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .getCodeBtn {
  padding-right: 10px;
}
</style>
